import { ALL_WAREHOUSES_OPTION, INVENTORY_STATUS_OPTIONS, PRODUCT_STATUS_OPTIONS } from "../constants"

import { useGetProductClassOptions } from "./useGetProductClassOptions"
import { useGetProductManagerOptions } from "./useGetProductManagerOptions"

import type { ComputedProductStatus, InventoryStatus } from "@/graphql/codegen/graphql"
import { useGetWarehouseOptions } from "@/hooks/useGetWarehouseOptions"
import type { Option } from "@/types/form-fields"

interface UseProductInventoryFilterOptionsReturn {
  productStatusOptions: Option<ComputedProductStatus>[]
  productInventoryStatusOptions: Option<InventoryStatus>[]
  productManagerOptions: Option<string>[]
  isProductManagerOptionsFetching: boolean
  productClassOptions: Option<string>[]
  isProductClassOptionsFetching: boolean
  warehouseOptions: Option<string>[]
  isWarehouseOptionsFetching: boolean
}

export const useProductInventoryFilterOptions = (): UseProductInventoryFilterOptionsReturn => {
  const { productManagerOptions, isFetching: isProductManagerOptionsFetching } = useGetProductManagerOptions()
  const { productClassOptions, isFetching: isProductClassOptionsFetching } = useGetProductClassOptions()
  const { warehouseOptions, isFetching: isWarehouseOptionsFetching } = useGetWarehouseOptions({
    isInventoryRelated: true,
  })

  return {
    productStatusOptions: PRODUCT_STATUS_OPTIONS,
    productInventoryStatusOptions: INVENTORY_STATUS_OPTIONS,
    productManagerOptions,
    isProductManagerOptionsFetching,
    productClassOptions,
    isProductClassOptionsFetching,
    warehouseOptions: [ALL_WAREHOUSES_OPTION, ...warehouseOptions],
    isWarehouseOptionsFetching,
  }
}
